import { useAuth } from "../hooks/useAuth";
import { AuthProvider } from "./auth-context";

export const AuthGate = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return;

  return <AuthProvider user={user}>{children}</AuthProvider>;
};
